import { applyMiddleware, compose, createStore } from 'redux';
import reduxThunk from 'redux-thunk';

import root_reducer, { IRootState } from 'redux/root_reducer';

// // Allow for Redux devtools
// TODO: This is causing an error with the typescript compiler, need to find a way to enable
// redux devtools, or remove this if not necessary
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Single application store
const store = createStore<IRootState, any, any, any>(
    root_reducer,
    composeEnhancers(applyMiddleware(reduxThunk))
);

export default store;



// WEBPACK FOOTER //
// ./src/redux/store.ts